// src/components/Footer.js
import React from 'react';
import '../App.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        © 2024 GET View
      </div>
      <div className="footer-right">
        <a href="#acerca-de">Acerca de</a>
        <a href="#privacidad">Privacidad</a>
        <a href="#terminos">Términos</a>
      </div>
    </div>
  );
};

export default Footer;
